import styled from 'styled-components';
import { Box } from '@mui/material';

export const ScrollableContainer = styled(Box)(() => ({
	flex: 1,
	overflow: 'auto',
	position: 'relative',
	scrollBehavior: 'smooth',
}));
